import { SchemaType } from '../form';
import { BoxExportDataTypes } from './boxTypes';
import comparisonTemplates from './comparison';
import listTemplates from './list';
import showcaseTemplates from './showcase';
import slimTemplates from './slim';
import tableTemplates from './table';

type boxTemplateTypes = {
  [K in keyof SchemaType]: BoxExportDataTypes[];
};

const boxTemplates: boxTemplateTypes = {
  showcase: showcaseTemplates,
  comparison: comparisonTemplates,
  slim: slimTemplates,
  list: listTemplates,
  table: tableTemplates,
};

export default boxTemplates;

// Types of Templates
// showcase => showcase
// cards-grid => cgrid
// table => table
// showroom => showroom
// list => list
// card-single => csingle
// list-slim => lslim

// ID template sring => "tk-{categoryName}-${templateName}-${number}"
